import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Injectable, inject } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { CaptureType } from '@sales/models/order-capture.model';
import { AppData } from '@app/shared/models/appdata.model';

const iconPath = 'assets/ice-icons';

@Injectable({
  providedIn: 'root',
})
export class CustomIconService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private appData = inject(AppData);

  registerIcons() {
    this.loadIcons(Object.values(IconNames), iconPath);
  }

  private loadIcons(iconKeys: string[], iconUrl: string) {
    iconKeys.forEach(key => {
      this.matIconRegistry.addSvgIcon(
        key,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.appData.baseUrl}/${iconUrl}/${key}.svg`)
      );
    });
  }

  getOrderCaptureIcon(captureType: string): IconNames {
    switch (captureType) {
      case CaptureType.CreateMBBSubscription:
      case CaptureType.CreateMBBSubscriptionWithHardware:
      case CaptureType.CreateMBBSubscriptionWithHardwareAndLogistics:
      case CaptureType.AddEquipment:
      case CaptureType.ChangeMbbSubscriptionOnExistingCustomer:
        return IconNames.ice_ruter;
      case CaptureType.CreateCellPhoneBundleWithGeneratedANumber:
      case CaptureType.CreateCellPhoneBundleWithCustomerSelectedANumber:
      case CaptureType.CreateCellPhoneBundleWithPorting:
      case CaptureType.CreateCellPhoneBundleWithExistingSubscription:
        return IconNames.ice_phone;
      case CaptureType.AddTradeInVoucher:
      case CaptureType.AddVendorSubsidyVoucher:
        return IconNames.ice_phone_trade_in;
      case CaptureType.CreateAccessoryBundleWithCustomerSelectedANumber:
      case CaptureType.CreateAccessoryBundleWithPorting:
      case CaptureType.CreateAccessoryBundleWithExistingSubscription:
        return IconNames.ice_power;
      case CaptureType.CreateSubscriptionWithGeneratedANumber:
      case CaptureType.CreateSubscriptionWithCustomerSelectedANumber:
      case CaptureType.CreateSubscriptionWithPorting:
      case CaptureType.UpdateServicesOnExistingSubscription:
      case CaptureType.ChangeSubscriberOnExistingSubscription:
      case CaptureType.ChangeSubscriptionOnExistingCustomerWithSubscriber:
      case CaptureType.NotImplemented:
      case CaptureType.ChangeSubscriptionOnExistingCustomer:
      default:
        return IconNames.ice_simcard;
    }
  }
}
